<div class="card-data card-top-margin col-height">
  <div class="card-heading fl-row">
    <div class="heading-text pt-2">
      <h5>Employee ( {{workforceData?.data?.length}} )</h5>
    </div>
    <div class="heading-more">
      <span class="material-icons">more_vert</span>
    </div>
  </div>
  @if (workforceData && workforceData.data) {
    <div class="endpoints-data card-box-dd col-child-height pl-4">
      <h6 class="endpont-top table-heading-description">Displaying
        {{ (p > 1) ? ((p-1) * itemsPerPage) : 1 }}-{{ (p > 1) ? (((p) * itemsPerPage) > workforceData.count) ? workforceData.count : ((p) * itemsPerPage) : 10 }}
      of {{workforceData.count}} Employee</h6>
      <div class="endpoint-table">
        <div class="endtable-head fl-row">
          <div class="endtable-head-col" style="width: 2% !important;">
            <input type="checkbox">
          </div>
          <div class="endtable-head-col">
            <span>{{ 'Name' | translate }}</span><i class="fa fa-sort"></i>
          </div>
          <div class="endtable-head-col"><span >{{ 'Role' | translate }}</span><i class="fa fa-sort"></i></div>
          <div class="endtable-head-col"><span >{{ 'Location' | translate }}</span><i class="fa fa-sort"></i></div>
          <div class="endtable-head-col"><span >{{ 'Department' | translate }}</span><i class="fa fa-sort"></i></div>
          <div class="endtable-head-col"><span >{{ 'EPs Managed' | translate }}</span></div>
        </div>
        @for (item of workforceData.data | paginate: { itemsPerPage: itemsPerPage, currentPage: p, totalItems:  workforceData.count }; track trackByIndex(i); let i = $index) {
          <div class="endatable-data-list fl-row"
            >
            <div class="endatable-data-col port" style="width: 2% !important;">
              <input type="checkbox">
            </div>
            <div #modalClick class="endatable-data-col table-second-col second-col-margin link-cursor"
              (click)="selectWorkforce(item)"> {{ item.fullName }}
              <!--          <span class="material-icons" *ngIf="item.ear_icon">hearing</span>-->
              <!--          <span class="material-icons" *ngIf="item.spark_icon">grain</span>-->
              <br/>
            </div>
            <div class="endatable-data-col">
              <div class="resi-text">
                {{ item.securityProfile }}
              </div>
            </div>
            <div class="endatable-data-col res-list">
              <!--          {{ item.location }}-->
            </div>
            <div class="endatable-data-col number-color">
              <!--          {{ item.department }}-->
            </div>
            <div class="endatable-data-col row">
              <div class="col-md-1">
                <!--            {{ item.ep_count }}-->
              </div>
              <div class="col-md-10 col-sm-10 col-10 endatable-data-col number-color">
                <button type="button">{{ 'Add' | translate }}</button>
              </div>
            </div>
          </div>
        }
      </div>
      <nav aria-label="Page navigation example">
        <pagination-template #pt="paginationApi" (pageChange)="onPageChange($event);"
          (pageBoundsCorrection)="p = $event">
          <ul class="pagination">
            <li class="page-item" [class.disabled]="pt.isFirstPage()">
              <a class="page-link" href="javascript:void(0)"
                (click)="pt.setCurrent(1)">First
              </a>
            </li>
            <li class="page-item" [class.disabled]="pt.isFirstPage()">
              <a class="page-link" href="javascript:void(0)"
                (click)="!pt.isFirstPage() && pt.previous()" aria-label="Previous">
                <span class="material-icons">arrow_back</span>
                <span class="sr-only">{{ 'Previous' | translate }}</span>
              </a>
            </li>
            @for (page of pt.pages; track trackByIndex($index)) {
              <li class="page-item"
                [class.current]="pt.getCurrent() === page.value">
                <a class="page-link" href="javascript:void(0)"
                  (click)="pt.getCurrent() !== page.value && pt.setCurrent(page.value)">
                  {{ page.label }}
                </a>
              </li>
            }
            <li class="page-item" [class.disabled]="pt.isLastPage()">
              <a class="page-link" href="javascript:void(0)"
                (click)="!pt.isLastPage() && pt.next()" aria-label="Next">
                <span class="material-icons">arrow_forward</span>
                <span class="sr-only">{{ 'Next' | translate }}</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="pt.isLastPage()">
              <a class="page-link" href="javascript:void(0)"
                (click)="pt.setCurrent(pt.getLastPage())">Last
              </a>
            </li>
          </ul>
        </pagination-template>
      </nav>
    </div>
  }
</div>

@if (workforceInfoOpen && selectedWorkforceData) {
  <app-workforce-info [selectedWorkforceData]="selectedWorkforceData"
  (successCallback)="hideView()"></app-workforce-info>
}
<div class="overlay" (click)="hideView()" [ngStyle]="{'display' : (workforceInfoOpen) ? 'block' : 'none'}"></div>
